export function createInspectionTemplateGeneralNormDocumentsBaseUrl(
  id: string
): string {
  return `/inspectionTemplate/${id}/generalNorm`;
}

export function createTemplateChecklistItemDocumentsBaseUrl(
  templateId: string,
  checklistItemId?: string
): string {
  return templateId && checklistItemId
    ? `/inspectionTemplate/${templateId}/checklistItem/${checklistItemId}/norm`
    : '';
}

export function createTemplateChecklistSectionDocumentsBaseUrl(
  templateId: string,
  sectionId?: string
): string {
  return templateId && sectionId
    ? `/inspectionTemplate/${templateId}/section/${sectionId}`
    : '';
}